import { NetworkUrlOfChainId, EthRPCEndpoints, ChainType, SubGovTokenAddress, ThetaRPCEndpoints } from 'common/constants';
const host = 'https://tsub7734-explorer.thetatoken.org';
const hostApi = 'https://tsub7734-explorer-api.thetatoken.org';
const hostWs = 'https://tsub7734-explorer-ws.thetatoken.org';
const config = {
    restApi: {
        host: hostApi,
        port: 443
    },
    socketApi: {
        host: hostWs,
        port: 443
    },
    defaultThetaChainID: NetworkUrlOfChainId[host],
    ethRPCEndpoint: "https://tsub7734-eth-rpc.passaways.com/rpc",
    thetaRPCEndPoint: "https://tsub7734-rpc.passaways.com/rpc",
    chainInfo: {
        metachain: {
            host: "https://metachain-explorer.thetatoken.org"
        },
        mainchain: {
            name: 'Theta Main Chain',
            description: 'The Main Chain serves as the Metachain Hub and coordinates the Subchains.',
            host: 'https://explorer.thetatoken.org',
            hostApi: 'https://explorer-api.thetatoken.org',
            hostWs: 'https://explorer-ws.thetatoken.org',
            logoName: "theta",
            restApiPort: 443,
            socketApiPort: 443
        },
        subchains: [{
            name: 'TPulse Subchain',
            description: 'Powering transparency across Theta EdgeCloud Every compute, every prompt, every insight - on chain.',
            host: 'https://tsub68967-explorer.thetatoken.org',
            hostApi: 'https://tsub68967-explorer-api.thetatoken.org',
            hostWs: 'https://tsub68967-explorer-ws.thetatoken.org',
            logoName: "tpulse",
            restApiPort: 443,
            socketApiPort: 443
        }, {
            name: 'Lavita AI Subchain',
            description: 'Lavita AI subchain, powers the first blockchain-AI based health information marketplace aiming to revolutionize the way 8 billion individuals around the world diagnose, analyze and treat health and genomic issues, leading to earlier intervention and improved outcome.',
            host: 'https://tsub360890-explorer.thetatoken.org',
            hostApi: 'https://tsub360890-explorer-api.thetatoken.org',
            hostWs: 'https://tsub360890-explorer-ws.thetatoken.org',
            logoName: "lavita",
            restApiPort: 443,
            socketApiPort: 443
        }, {
            name: 'Passaways Subchain',
            description: 'Custom-built for the Passaways/PLASM ecosystem on Theta. Governed by PLASM.',
            host: 'https://tsub7734-explorer.thetatoken.org',
            hostApi: 'https://tsub7734-explorer-api.thetatoken.org',
            hostWs: 'https://tsub7734-explorer-ws.thetatoken.org',
            logoName: "passaways",
            restApiPort: 443,
            socketApiPort: 443
        }, {
            name: 'Grove Subchain',
            description: 'GROVE subchain powers the next-gen GroveWars Web3 gaming ecosystem and 3D Character Builder.',
            host: 'https://tsub47683-explorer.thetatoken.org',
            hostApi: 'https://tsub47683-explorer-api.thetatoken.org',
            hostWs: 'https://tsub47683-explorer-ws.thetatoken.org',
            logoName: "grove",
            restApiPort: 443,
            socketApiPort: 443
        }]
    },
    chainName: 'Passaways Subchain',
    chainType: ChainType.SUBCHAIN,
    subGovTokenAddress: '0x5c2fB1E2594E85C5f1579b07DD5b8DFEA3F929E0',
    tokenMap: {},
    hasAbout: true,
    chainDescription: 'Custom-built for the Passaways/PLASM ecosystem on Theta. Governed by PLASM.',
    logoName: 'passaways',
    links: {
        website: "https://www.passaways.com",
        whitePaper: "https://www.passaways.com/pdfs/plasm-darkpaper-latest.pdf",
        cmc: "",
        ck: "",
        tg: "",
        twitter: "https://twitter.com/thepassaways",
        discord: "https://discord.com/invite/5wgRAbPa5H",
        medium: ""
    },
    tokenName: "plasm"
};
export default config;
